<template>

 <one-column-layout class="dark"
                    :class="['space-l']"
                    slot="sidebar">

  <title-bar title="Cases"
             slot="titleBar"
             type="page"
             :action-menu="!isDesktop"
             @menu="toggleNav" >

    <p>( {{ filteredCount }} )</p>
   <div class="smd-spacer"/>


   <smd-options pilled tiny
                :title="activeCaseFilter"
                :items="$options.CasesFilters"
                @item-selected="filterPatientByCase"/>

   <div class="form__row" v-show="isDesktop" v-if="!isPreview">
    <label >FROM</label>
    <smd-date-input v-model="fromDate"/>
    <label >TO</label>
    <smd-date-input v-model="toDate"/>
   </div>


   <smd-btn bg icon="smd-icon-action-add"
            @click="showNewPatientCaseForm"></smd-btn>
  </title-bar>

  <div class="toolbar" slot="subtitleBar">
   <div class="search dark">
    <i class="smd-icon-action-search"></i>
    <input type="text"
           placeholder="Search Case Number"
           id="searchText"
           v-model="searchText"/>
   </div>

   <label v-show="isDesktop" v-if="!isPreview">View</label>
   <smd-segment v-if="isDesktop"
                type="pill solid"
                :items="withoutOpenCaseFilters"
                v-model="activeFilter"
                v-show="!isPreview"/>
   <smd-options v-if="!isDesktop || isPreview"
                pilled tiny
                :title="activeFilter"
                :items="withoutOpenCaseFilters"
                @item-selected="filterListForPreview"/>
  </div>

  <div class="pogs-list--panels compact patient-list"
       :class="[undefined]">

   <pogs-list-item-cases v-for="(patientcase) in filteredCases"
                           :key="patientcase._id"
                           :patientcase="patientcase"
                           :showPreview="false"
                           :selectedUser="patientcase.patientid"/>

   <infinite-loading :identifier="identifierId" spinner="circles" @infinite="infiniteHandler">
    <div slot="no-more"></div>
   </infinite-loading>

  </div>

 </one-column-layout>

</template>

<script>

 import InfiniteLoading from 'vue-infinite-loading';
 import {mapGetters, mapActions} from 'vuex'
 import {GETTER_SHOW_PREVIEW} from '../../../store/modules/shared'
 import PogsListItemCases from './pogs-list__item--cases'
 import Routes from '../../../router/route-constants'
 import {fromEvent} from 'rxjs'
 import {debounceTime, distinctUntilChanged} from 'rxjs/operators'
 import {
   ACTION_LOAD_PATIENT_CASE_LIST_NEXTPAGE,
   ACTION_LOAD_PATIENT_CASES_LIST
 } from '../../../store/modules/patients'
 const LIMIT_PER_PAGE = 100;

 import uiHelper from '../../../mixins/uihelper'

 export default {
  name: "pogs-list--cases",
  mixins: [uiHelper],
  components: {
    PogsListItemCases,
   InfiniteLoading
  },
  props: {
   patientcases: Array,
   patientCount: Object
  },
  data(){
   return{
    activeFilter : 'openCase',
    activeCaseFilter : 'allCases',
    page: 1,
    loading: false,
    searchText: '',
    identifierId: 1,
    fromDate: null,
    toDate: null,
    filteredCount: 0,
   }
  },
  computed: {
   ...mapGetters({
    isPreview: GETTER_SHOW_PREVIEW
   }),
   isDesktop(){
    return this.$mq.desktop;
   },
    withoutOpenCaseFilters() {
      return this.activeCaseFilter === "archivedCases"
          ? this.$options.Filters.filter((f) => f.val !== "openCase")
          : this.$options.Filters;
    },
    filteredCases() {
      if (this.activeCaseFilter === "archivedCases") {
        return this.patientcases;
      }
      return this.patientcases.filter(c => !c.isArchived);
    }
  },
  methods: {
   ...mapActions({
    loadPatientList: ACTION_LOAD_PATIENT_CASES_LIST,
    loadPatientListNextPage: ACTION_LOAD_PATIENT_CASE_LIST_NEXTPAGE
   }),
   showNewPatientCaseForm(){
    this.$router.push({name: Routes.ROUTE_NEW_PATIENT_CASE_INFO});
   },
   filterPatientList(search, tag, cases, fromdate, todate){
    const params = {search, tag, cases, fromdate, todate};
    this.$store.dispatch(ACTION_LOAD_PATIENT_CASES_LIST, params)
   },
   filterListForPreview(item){
     if (this.activeCaseFilter !== "archivedCases") {
       this.activeFilter = item.val;
     }
   },
    filterPatientByCase(item) {
      this.activeCaseFilter = item.val;
      this.identifierId = this.activeCaseFilter + '123';
      this.filteredCount = 0;
      if (this.activeCaseFilter === "archivedCases") {
        this.activeFilter = "allPatients";
      }
      this.filterPatientList(this.searchText, this.activeFilter, this.activeCaseFilter, this.fromDate, this.toDate);
    },
   infiniteHandler($state){
    const page     = Math.floor(this.patientcases.length/LIMIT_PER_PAGE) + 1;
    const search   = this.searchText;
    const tag      = this.activeFilter;
    const cases    = this.activeCaseFilter;
    const todate   = this.toDate;
    const fromdate = this.fromDate;
    const params = {page, search, tag, cases, fromdate, todate};
    this.loadPatientListNextPage(params).then((message) => {
     const temp = message instanceof Object ? Object.keys(message) : {};
     if(Object.keys(temp).length < LIMIT_PER_PAGE){
      $state.complete()
     }
     $state.loaded();
    });
   },
   updateFilter(identifier){
    //identify is used to reset infinite scroll
    this.identifierId = identifier;
    this.filterPatientList(this.searchText, this.activeFilter, this.activeCaseFilter, this.fromDate, this.toDate)
   }
  },
  watch:{
   activeFilter: function() {
    this.updateFilter(this.activeFilter + '@123!');
   },
   toDate: function() {
    this.updateFilter(this.toDate + '@123!');
   },
   fromDate: function() {
    this.updateFilter(this.fromDate + '@123!');
   },
    patientcases: {
      handler() { this.filteredCount = this.filteredCases.length;},
      immediate: true
    }
  },
  Filters: [
   { val: 'openCase'    , label: 'Open Case'},
   { val: 'allPatients' , label: 'All' },
  ],
  CasesFilters: [
   { val: 'allCases'    , label: 'All Cases' },
   { val: 'obCases'     , label: 'OB Cases'},
   { val: 'gyneCases'   , label: 'Gyne Cases'},
   { val: 'archivedCases', label: 'Archived Cases' }
  ],
  mounted() {

   let searchText = document.getElementById("searchText");
   const onSearch = fromEvent(searchText,'input');
   onSearch.pipe(debounceTime(500), distinctUntilChanged())
           .subscribe((data) => {
            this.identifierId = data.target.value;
            this.filterPatientList(data.target.value, this.activeFilter, this.activeCaseFilter, this.fromDate, this.toDate);
           })

  }
 }
</script>

<style lang="scss">
  @import "../../../scaffolding/scss/pogs-util";

  @media (max-width: 863px) {
   .page header p {
    font-size: 12px;
    width: 30px;
   }
   .page header > *:not(:last-child) {
    margin-right: 5px !important;

    .smd-date-input {
     width: 150px;
    }
   }
  }

  @media (max-width: 767px) {
   .page header > *:not(:last-child) {
    margin-right: 8px !important;
   }
    .pseudo-dialog {
      display: none !important;
    }
  }

  .patient-list {
    .pogs-list__item {
      display: grid !important;
      @include make-grid-cols(50px 1fr 20px, space(s));
    }
  }

  .minify {

    .pogs-list__item {
      grid-template-columns: 40px 1fr 10px;
      align-items: flex-start !important;

      @include transition;

      &.active,
      &:hover {
        margin-right: -3px;
        margin-left: -3px;

        .patient-data__details {
          p {
            font-size: 15px;
          }
        }
      }
    }

    .patient-data__details {
      p {
        font-size: 13px;
      }
    }

    .patient-data__status {
      @include space-me($t: xs);
      max-width: 270px;
    }

  }

  .patient-img,
  .patient-case {
    @extend %flex-row--center-xy;
  }

  .patient-data__status {
    @extend %flex-row--center-x;

    min-width: 150px;

    [class^='pogs-tag'] {
      margin-right: space(s);
    }

    label {
      @extend %text-overflow-ellipsis;
    }
  }

  .patient-case__status {
    @extend %border-radius-circle;

    width: 10px;
    height: 10px;

    &.open {
      background: color(red, tags);
    }
  }

  .patient-data{
    @extend %flex-row--wrap;
    width: 100%;
  }

  .patient-data__details{
    max-width: 500px;

    flex: 1;
    @include responsive(mobile) {
      max-width: 235px;
    }

    & > .patient-data__meta{
      @include space-me($t: xs);
      @include make-grid-cols(175px 52px, space(s));
    }

    p{
      color: color(light);
    }

    label{
      margin-right: space(xs);
    }
  }

</style>
